import * as React from "react";
import { forwardRef } from "react";
const SvgSystemStations = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/buliding" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M2 22H22M7 16.5H10M14 16.5H17M7 12H10M14 12H17M7 7.5H10M14 7.5H17M17 2H7C4 2 3 3.79 3 6V22H21V6C21 3.79 20 2 17 2Z", stroke: "#05A35C", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgSystemStations);
export default ForwardRef;
